import axios from 'axios';
import { getAdsConfig } from '../../services/getAdsConfig'

const state = {
    scroogeConfig: null,
};

const actions = {
    async getScroogeConfig ({ commit }, params) {
        const filter = { projectKey: params.projectKey, isMobile: params.isMobile };
        try {
            const config = await getAdsConfig({ filter });
            commit('scroogeConfig', config);
            return config;
        } catch (err) {
            console.warn(err);
            console.warn('[CreativeManager]: ошибка получения конфига', JSON.stringify({ filter }));
        }
      },
};

const mutations = {
    scroogeConfig (state, value) {
        state.scroogeConfig = value
      }
};

const getters = {
    scroogeConfig({ scroogeConfig }) {
        return scroogeConfig;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/adv.js